// Get API URL from runtime config (injected by Docker) or fallback to production
const API_BASE_URL = (window.ENV && window.ENV.API_URL) || 'https://spheroid.scaleapp.tech/api';

class ApiService {
  async makeRequest(endpoint, options = {}) {
    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
        ...options,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`API request failed for ${endpoint}:`, error);
      // Return fallback data or rethrow error based on your needs
      throw error;
    }
  }

  async getSystemHealth() {
    return this.makeRequest('/system-health');
  }

  async getRecentAlerts() {
    return this.makeRequest('/recent-alerts');
  }

  async getProcessingMetrics() {
    return this.makeRequest('/processing-metrics');
  }

  async getPipelineStatus() {
    return this.makeRequest('/pipeline-status');
  }

  async getMonitoringLayers() {
    return this.makeRequest('/monitoring-layers');
  }

  async getSatelliteConnections() {
    return this.makeRequest('/satellite-connections');
  }

  async getLogs() {
    return this.makeRequest('/logs');
  }

  async getPipelines() {
    return this.makeRequest('/pipelines');
  }

  async getValidationRules() {
    return this.makeRequest('/validation-rules');
  }

  async getWebServices() {
    return this.makeRequest('/web-services');
  }

  async getExternalSources() {
    return this.makeRequest('/external-sources');
  }

  async getLiveMetrics() {
    return this.makeRequest('/live-metrics');
  }

  async getExternalSourcesDetailed() {
    return this.makeRequest('/external-sources-detailed');
  }

  async getGeoServerLayers() {
    return this.makeRequest('/geoserver-layers');
  }

  async getDashboardMetrics() {
    return this.makeRequest('/dashboard-metrics');
  }

  async getNotificationSettings() {
    return this.makeRequest('/notification-settings');
  }

  async getNotificationRules() {
    return this.makeRequest('/notification-rules');
  }
}

export const apiService = new ApiService();
export default apiService;